module.exports = __webpack_public_path__ + "media/images/hero-2-b83ebce9.jpg";